module.exports = {
  "className": "MemberDetail",
  "classNameLabel": "Member",
  "limit": 7,
  "deleteColumn": "name",
  "columns": [
    {
      "columnName": "objectId",
      "type": "string"
    },
    {
      "columnName": "memberId",
      "columnLabel": "member id",
      "type": "string"
    }, 
    {
      "columnName": "cardType",
      "columnLabel": "card Type",
      "type": "string"
    },
    // {
    //   "columnName": "deviceToken",
    //   "type": "string",
    //   "show": false
    // },
    // {
    //   "columnName": "uuid",
    //   "type": "string",
    //   "show": false
    // },
    // {
    //   "columnName": "name",
    //   "type": "string"
    // }, {
    //   "columnName": "facebookName",
    //   "type": "string"
    // },{
    //   "columnName": "email",
    //   "type": "string"
    // }, {
    //   "columnName": "facebookEmail",
    //   "type": "string"
    // }, {
    //   "columnName": "facebookId",
    //   "type": "string"
    // },
    {
      "columnName": "createdAt",
      "columnLabel": "created At",
      "type": "Date",
      format: "MM/DD/YYYY hh:mm:ss A",
      show: true
    }, {
      "columnName": "updatedAt",
      "type": "Date"
    }
  ]
}



// WEBPACK FOOTER //
// ./components/schema/MemberDetail.js